import { req, withParams } from 'vuelidate/lib/validators/common'

export default (param) =>
  withParams({ type: 'regexp', param }, (value) => {
    const regexp = new RegExp(typeof param === 'function' ? param() : param)
    return !req(value) || regexp.test(value)
  })
